/**
 * Factory: gridDefinition
 */
angular.module('acme.common.factory.gridDefinition', [
  'angularUUID2',
  'acme.common.service.config',
  'acme.common.service.api',
  'acme.common.service.userPreferences',
  'acme.common.service.helpers'
])
.factory('GridDefinitionFactory', [
  '$rootScope',
  '$timeout',
  '$parse',
  'ConfigService',
  'ApiService',
  'UserPreferencesService',
  'uuid2',
  'HelpersService',
  'uiGridConstants',
  function GridDefinitionFactory(
    $rootScope,
    $timeout,
    $parse,
    ConfigService,
    ApiService,
    UserPreferencesService,
    uuid2,
    HelpersService,
    uiGridConstants
  ) {

  function GridDefinition() {
    function isFunction(maybeFunction) {
      return maybeFunction && typeof maybeFunction === 'function';
    }

    return {

      constructor: GridDefinition,
      
      init: function(name, options, viewId, loadPreferences) {

        var self = this;
        var preferences = UserPreferencesService.getPreferences();

        if (options.useAccessibleGrid === undefined || options.useAccessibleGrid === null) {
          this.isAccessbilityEnabled = preferences.accessibilityEnabled;
        } else {
          this.isAccessbilityEnabled = options.useAccessibleGrid;
        }

        this.reset();

        this.loadPreferences = loadPreferences || false;
        this.viewId = viewId || '';
        this.paginationPageSizes = [25, 50, 100, 150, 200];

        this.gridOptions = options || {};

        if (name) {
          options.gridName = name;
        }

        if (this.gridOptions.paginationPageSizes) {
          this.paginationPageSizes = this.gridOptions.paginationPageSizes;
        }
        
        if (this.gridOptions.initialGridState) {
          if (this.gridOptions.initialGridState.page) {
            this.page = this.gridOptions.initialGridState.page;
          }

          if (this.gridOptions.initialGridState.pageSize) {
            this.pageSize = this.gridOptions.initialGridState.pageSize;
          }

          if (this.gridOptions.initialGridState.sortField) {
            this.sortField = this.gridOptions.initialGridState.sortField;
          }

          if (this.gridOptions.initialGridState.sortDirection) {
            this.sortDirection = this.gridOptions.initialGridState.sortDirection;
          }
        }

        if (options && (options.enableRowSelection !== undefined) ) {
          options.enableRowHeaderSelection = options.enableRowSelection;
        }

        this.initDefaults();

        if (this.isAccessbilityEnabled) {
          this.initAccessibleGrid();
        }

        this.load({
          type: ConfigService.settingsTypes.view,
          name: this.viewId
        });

      },

      reset: function() {
        this.isLoaded = false;
        this.userPreferences = false;
        this.userPreferencesLoaded = false;
        this.agSortChanged = false;

        this.options = {};
        this.gridOptions = {};

        this.sortField = "";
        this.sortDirection = "";

        this.gridHeight = {
          height: 0
        };
      },

      initDefaults: function() {
        var self = this;
        var rowClass = (this.gridOptions && this.gridOptions.rowClasses) ? ' ng-class="'+this.gridOptions.rowClasses+'"' : ' ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }"';
        var defaultOptions;

        if (this.gridOptions.draggable){
          this.gridOptions.rowTemplate = "<div grid=\"grid\" class=\"ui-grid-draggable-row\" draggable=\"true\"><div ng-dblclick=\"grid.appScope.onDblClick(row)\" ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name\" " +
          "class=\"ui-grid-cell\" " + rowClass + " ui-grid-cell ></div></div>";
        }else {
          this.gridOptions.rowTemplate = "<div ng-dblclick=\"grid.appScope.onDblClick(row)\" ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name\" " +
            "class=\"ui-grid-cell\" " + rowClass + " ui-grid-cell ></div>";
        }

        var canSelectRow = function (options) {
          return true;
        };

        if (this.isAccessbilityEnabled) {
          defaultOptions = this.getAccessibleGridDefaults();
          if (this.gridOptions.enablePagination !== undefined && this.gridOptions.enablePagination === false) {
            this.gridOptions.enablePaginationControls = false;
          }
          this.options = angular.extend(defaultOptions, { canSelectRow: canSelectRow }, this.gridOptions);
        } else {
          defaultOptions = this.getAGGridDefaults();
          this.options = angular.extend(defaultOptions, { canSelectRow: canSelectRow }, this.gridOptions);
          this.options.rowHeight = this.gridOptions.rowHeight || this.options.rowHeight;
          this.options.rowSelection = this.gridOptions.multiSelect ? 'multiple' : 'single';
          this.options.rowDeselection = false;
          this.options.pageSize = this.gridOptions.paginationPageSize || this.options.pageSize;
          this.options.paginationPageSizes = this.paginationPageSizes;
          if ((this.gridOptions.useExternalSorting !== undefined && !this.gridOptions.useExternalSorting) ||
              (this.gridOptions.useExternalPagination !== undefined && !this.gridOptions.useExternalPagination)) {
            this.options.enableServerSideSorting = false;
          }
          this.options.enableSorting = !this.options.enableServerSideSorting;
          if (this.gridOptions.enableGridMenu !== undefined) {
            this.options.enableGridMenu = this.gridOptions.enableGridMenu;
          } else {
            this.options.enableGridMenu = true;
          }
          this.setAGGridColumns(this.options.columnDefs);
        }

        this.setColumnConfig(this.options.columnDefs);
      },

      getAccessibleGridDefaults: function() {
        var self = this;
        return {
          enableVerticalScrollbar: 0,
          enableHorizontalScrollbar: 0,
          showGridFooter: true,
          enableColumnMenus: false,
          enableCellEdit: false,
          enableRowHeaderSelection: false,
          enableRowSelection: true,
          showTreeRowHeader: false,
          enableExpandAll: false,
          enableSelectionBatchEvent: false,
          enableGridMenu: true,
          exporterMenuCsv: false,
          exporterMenuPdf: false,
          draggable: false,
          multiSelect: false,
          noUnselect: true,
          rowHeight: 30,
          enableColumnResizing: true,
          enableColumnMoving: true,
          enableSorting: true,
          enablePagination: true,
          useExternalSorting: true,
          useExternalPagination: true,
          enablePaginationControls: true,
          paginationCurrentPage: 1,
          paginationPageSizes: this.paginationPageSizes,
          paginationPageSize: 50,
          minRowsToShow: 1,
          totalItems: 0,
          treeRowHeaderAlwaysVisible: false,
          flatEntityAccess: false,
          saveFilter: false,
          saveFocus: false,
          saveGrouping: false,
          savePinning: false,
          saveSelection: false,
          saveSort: false,
          saveTreeView: false,
          saveWidths: true,
          rowTemplate: (this.gridOptions.draggable) ? "<div grid=\"grid\" class=\"ui-grid-draggable-row\" draggable=\"true\"><div ng-dblclick=\"grid.appScope.onDblClick(row)\" ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name\" " +
            "class=\"ui-grid-cell\" ng-class=\"{ \'ui-grid-row-header-cell\': col.isRowHeader }\" ui-grid-cell ></div></div>": "<div ng-dblclick=\"grid.appScope.onDblClick(row)\" ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name\" " +
        "class=\"ui-grid-cell\" ng-class=\"{ \'ui-grid-row-header-cell\': col.isRowHeader }\" ui-grid-cell ></div>",

          gridFooterTemplate: 'common/directives/dataGrid/customUiGridFooterTemplate.tpl.html',
          headerTemplate: 'common/directives/dataGrid/customUiGridHeaderTemplate.tpl.html',

          gridMenuCustomItems: [{
          title: 'Export visible data as pdf',
          order: 100,
          action: function ($event){
            self.gridApi.exporter.pdfExport('visible', 'visible');
          }
          }],
          exporterPdfHeader: '',
          exporterPdfFooter: '',
          exporterSuppressColumns: [ 'edit', 'view', 'order', 'cancel', 'booking', 'delete', 'remove' ],
          keyDownOverrides: [{ keyCode: 13, ctrlKey: false }],
          isRowSelectable: function(row) {
            var r = true;
            if (row.entity.hasOwnProperty('$$treeLevel')) {
              r = false;
            }
            return r;
          }
        };
      },

      getAGGridDefaults: function() {
        var self = this;
        return {
          angularCompileRows: true,
          pageSize: 50,
          rowSelection: 'single',
          enableSorting: true,
          enableServerSideSorting: true,
          enableColResize: true,
          enablePagination: true,
          enableFilter: false,
          groupHeaders: false,
          rowModelType: 'pagination',
          rowHeight: 30,
          headerHeight: 0,
          localeText: {
            page: '&nbsp;',
            next: '<i class="fa fa-caret-right fa-lg"></i>',
            last: '<i class="fa fa-step-forward fa-md"></i>',
            first: '<i class="fa fa-step-backward fa-md"></i>',
            previous: '<i class="fa fa-caret-left fa-lg"></i>'
          },
          icons: {
            sortAscending: '<i class="fa fa-caret-up"/>',
            sortDescending: '<i class="fa fa-caret-down"/>'
          },
          overlayLoadingTemplate: '<span class="ag-overlay-loading-center text-center inactive">Loading...</span>',
          overlayNoRowsTemplate: '<span class="ag-overlay-no-items text-center inactive">No items found</span>',
          /**
          * @param {{
          *  column: Column,
          *  columns: Column[],
          *  toIndex: number,
          *  type: 'columnMoved',
          * }} params
          */
          onColumnMoved: HelpersService.utils.debounce(function (params) {
            self.columnMoved(params);
          }, 500),
          onColumnResized: function (params) {
            self.columnResized(params);
          },
          onRowDoubleClicked: function(params) {
            self.rowDoubleClicked(params);
          },
          onRowSelected: function (params) {
            self.rowSelected(params);
          },
          onSelectionChanged: _.debounce(function () {
            self.selectionChanged();
          }, 0),
          onRowClicked: function(params) {
            self.rowClicked(params);
          },
          onBeforeSortChanged: function(params) {
            self.agSortChanged = true;
          },
          onCellClicked: function(params) {
            self.cellClicked(params);
          },
          onCellValueChanged: function(params) {
            self.cellValueChanged(params);
          }
        };
      },

      initAccessibleGrid: function() {
        var self = this;

        this.options = angular.extend(this.options, {
          onRegisterApi: function(gridApi) {            
            self.gridApi = gridApi;
            var appScopeProvider = gridApi.grid.options.appScopeProvider;

            self.updateGridHeight();

            if (appScopeProvider && appScopeProvider.customClientFilter && isFunction(appScopeProvider.customClientFilter)){
              gridApi.grid.registerRowsProcessor(appScopeProvider.customClientFilter, 200);
            }

            if (appScopeProvider && isFunction(appScopeProvider.expandGroupedRows)) {
              appScopeProvider.expandGroupedRows();
            } else {
              self.expandGroupedRows();
            }

            if (gridApi.grid.options) {
              gridApi.core.on.sortChanged( $rootScope, function(grid, columns) {
                var sortModel;
                if (columns && columns.length > 0) {
                  sortModel = {
                    field: columns[0].colDef.colId || columns[0].field,
                    sort: {
                      direction: columns[0].sort.direction
                    }
                  };
                  if (self.sortField !== sortModel.field || self.sortDirection !== sortModel.sort.direction) {
                    if (appScopeProvider && isFunction(appScopeProvider.onDataGridSortChange)) {
                      appScopeProvider.onDataGridSortChange(grid, [sortModel]);
                    }
                    self.sortField = sortModel.field;
                    self.sortDirection = sortModel.sort.direction;
                    self.updateUserPreferences();
                  }
                }
              });
            }else {
              gridApi.core.on.sortChanged( $rootScope, function(grid, columns) {
                var sortModel;
                if (columns && columns.length > 0) {
                  sortModel = {
                    field: columns[0].colDef.colId || columns[0].field,
                    sort: {
                      direction: columns[0].sort.direction
                    }
                  };
                  if (self.sortField !== sortModel.field || self.sortDirection !== sortModel.sort.direction) {
                    $rootScope.$broadcast('DataGrid::sortChange', {
                      field: sortModel.field,
                      direction: sortModel.sort.direction
                    });
                    self.sortField = sortModel.field;
                    self.sortDirection = sortModel.sort.direction;
                    self.updateUserPreferences();
                  }
                }
              });
            }

            gridApi.cellNav.on.viewPortKeyDown($rootScope, function(event, rowCol) {
              if ((event.keyCode === 13 || event.keyCode === 32) && !rowCol.col.colDef.enableCellEdit && isFunction(rowCol.col.colDef.onCellNavClick)) {
                rowCol.col.colDef.onCellNavClick(rowCol.row, rowCol.col, event);
              }
            });

            gridApi.cellNav.on.viewPortKeyPress($rootScope, function(event, rowCol) {
              if ((event.keyCode === 13 || event.keyCode === 32) && !rowCol.col.colDef.enableCellEdit && isFunction(rowCol.col.colDef.onCellNavClick)) {
                rowCol.col.colDef.onCellNavClick(rowCol.row, rowCol.col, event);
              }
            });

            if (gridApi.grid.options.useExternalPagination) {
              gridApi.pagination.on.paginationChanged($rootScope, function(newPage, pageSize){
                if (self.pageSize !== pageSize || self.page !== newPage) {
                  self.page = newPage;
                  self.pageSize = pageSize;
                  if (appScopeProvider && isFunction(appScopeProvider.onDataGridPaginate)) {
                    appScopeProvider.onDataGridPaginate(newPage, pageSize);
                  }
                  self.updateUserPreferences();
                  self.updateGridHeight();
                }
              });
            }else {
              gridApi.pagination.on.paginationChanged($rootScope, function(newPage, pageSize) {
                if (self.pageSize !== pageSize || self.page !== newPage) {
                  $rootScope.$broadcast('DataGrid::paginate', {
                    page: newPage,
                    pageSize: pageSize
                  });
                  self.page = newPage;
                  self.pageSize = pageSize;
                  self.updateUserPreferences();
                  self.updateGridHeight();
                }
              });
            }

            // Note: There is a bug in the originalPosition and newPosition values - if a column is moved to the 0th position, it reports 0 when it should report 1. Ensure that there is a check for this.
            if (gridApi.grid.options.enableColumnMoving) {
              gridApi.colMovable.on.columnPositionChanged($rootScope, function(changedColumn, originalPos, newPos) {
                var gState = gridApi.saveState.save();
                if (appScopeProvider && isFunction(appScopeProvider.onDataGridColumnReordered)) {
                  appScopeProvider.onDataGridColumnReordered(changedColumn, originalPos, newPos, gState.columns);
                }
                self.setColumnConfig(gState.columns);
                self.updateUserPreferences();
              });
            } else {
              gridApi.colMovable.on.columnPositionChanged($rootScope, function (colDef, originalPosition, newPosition) {
                var gState = gridApi.saveState.save();
                $rootScope.$broadcast('DataGrid::EventColumns', {
                  col: colDef,
                  originalPosition: originalPosition,
                  newPosition: newPosition,
                  columns: gState.columns
                });
                self.setColumnConfig(gState.columns);
              });
            }

            gridApi.colResizable.on.columnSizeChanged($rootScope, function(colDef, deltaChange){
              var gState = gridApi.saveState.save();
              self.setColumnConfig(gState.columns);
              self.updateUserPreferences();
            });

            gridApi.selection.on.rowSelectionChanged($rootScope, function(e) {
              if (e.isSelected) {
                var row;
                var mid = 0;
                var el = $(e.grid.element);
                var uuid = el.attr('data-uuid') || uuid2.newuuid();
                var wrapper = el.find('div.ui-grid-viewport').position().top;
                var header = el.find('div.ui-grid-header').height();

                if (!el.attr('data-uuid')) {
                  el.attr('data-uuid', uuid);
                }

                $timeout(function(){
                  row = el.find('div.ui-grid-row-selected');

                  if (row.length) {
                    mid = row.first().position().top + wrapper + header + Math.floor(gridApi.grid.options.rowHeight / 2);

                    if (!gridApi.grid.options.enablePagination) {
                      mid = mid - 35;
                    }
                  }

                  if (row.length) {
                    $rootScope.$broadcast('DataGrid::UpdateCursor', {
                      uuid: uuid,
                      position: {
                        display: 'block',
                        top: mid + 'px',
                        left: '-6px'
                      }
                    });
                  }
                }, 10);
              }
            });

            if (gridApi.grid.options.enableRowSelection) {
              if (appScopeProvider && isFunction(appScopeProvider.onDataGridSelectionChange)) {
                gridApi.selection.on.rowSelectionChanged($rootScope, function (row) {
                  /**
                   * This filter is here because the accesible grid is giving us an inclusive selected rows
                   * and we need to know how many rows have been selected before the row we just clicked was selected.
                   */
                  var selectedRows = gridApi.selection.getSelectedRows().filter(function (item) {
                    return item !== row.entity;
                  });

                  if (!self.options.canSelectRow({ row: row, selectedRows: selectedRows })) {
                    gridApi.selection.unSelectRow(row);
                    row.isSelected = false;
                  }

                  return appScopeProvider.onDataGridSelectionChange(row, gridApi.selection.getSelectedRows());
                });
              }
            }

            // works on any cell edit if enableCellEdit is true (even if gridOptions has enableCellEdit set to false
            if (appScopeProvider && isFunction(appScopeProvider.onAfterCellEdit)) {
              gridApi.edit.on.afterCellEdit($rootScope, appScopeProvider.onAfterCellEdit);
            }

            if (gridApi.grid.options.rowReordering === true || gridApi.grid.options.rowReordering === 'true') {
              gridApi.draggableRows.on.rowDropped($rootScope, function (info, rowElement) {
                if (appScopeProvider && isFunction(appScopeProvider.onRowDropped)) {
                  appScopeProvider.onRowDropped(info.fromIndex, info.toIndex, info.draggedRowEntity, rowElement);
                }
              });
            }

            if (gridApi.grid.options.enableGridMenu) {
              gridApi.core.on.columnVisibilityChanged( $rootScope, function(changedColumn) {
                var gState = gridApi.saveState.save();
                if (appScopeProvider && isFunction(appScopeProvider.onDataGridColumnChanged)) {
                  appScopeProvider.onDataGridColumnChanged(changedColumn, gState.columns);
                }
                self.setColumnConfig(gState.columns);
                self.updateUserPreferences();
              });
            } else {
              gridApi.core.on.columnVisibilityChanged($rootScope, function (changedColumn) {
                var gState = gridApi.saveState.save();
                $rootScope.$broadcast('DataGrid::ColumnChanged', {
                  col: changedColumn,
                  columns: gState.columns
                });
                self.setColumnConfig(gState.columns);
              });
            }

            if (appScopeProvider) {
              appScopeProvider.cellNavSort = function(col, event) {
                if ((event.keyCode === 13 || event.keyCode === 32) && col.enableSorting) {
                  if (col.sort.direction) {
                    col.sort.direction = (col.sort.direction === 'desc') ? 'asc' : 'desc';
                  } else {
                    col.sort.direction = 'asc';
                  }
                  gridApi.grid.sortColumn(col, col.sort.direction, false);
                  if (!gridApi.grid.options.useExternalSorting) {
                    gridApi.grid.api.core.refresh();
                  }
                }
              };
            } else {
              gridApi.grid.appScope.cellNavSort = function(col, event) {
                if ((event.keyCode === 13 || event.keyCode === 32) && col.enableSorting) {
                  if (col.sort.direction) {
                    col.sort.direction = (col.sort.direction === 'desc') ? 'asc' : 'desc';
                  } else {
                    col.sort.direction = 'asc';
                  }
                  gridApi.grid.sortColumn(col, col.sort.direction, false);
                  if (!gridApi.grid.options.useExternalSorting) {
                    gridApi.grid.api.core.refresh();
                  }
                }
              };
            }
          }
        }, this.gridOptions);

        this.setColumnConfig(this.options.columnDefs);

      },

      getUserPreferences: function() {
        var self = this;
        if (this.loadPreferences) {
          if (ConfigService.isPreferencesLoadedForKey(ConfigService.settingsTypes.view, this.viewId, this.options.gridName)) {
            this.userPreferences = ConfigService.getPreferencesByKey(ConfigService.settingsTypes.view, this.viewId, this.options.gridName);
            if (this.userPreferences) {
              this.setColumns(this.options.columnDefs, this.userPreferences);
              this.applyPreferences(this.userPreferences);
            }else {
              // set default state for this grid if needed
              this.setColumns(this.options.columnDefs, null);
            }
          }
        }else {
          // set default state for this grid if needed
          this.setColumns(this.options.columnDefs, null);
        }
        this.userPreferencesLoaded = true;

        if (this.isAccessbilityEnabled) {
          this.initAccessibleGrid();
          $timeout(function() {
            $rootScope.$broadcast('DataGrid::UserPreferencesLoaded', {viewId: self.viewId, gridName: self.options.gridName});
          }, 0);
        } else {
          this.options.pageSize = this.gridOptions.paginationPageSize || this.options.pageSize;
          this.setAGGridColumns(this.options.columnDefs);
          $timeout(function() {
            $rootScope.$broadcast('DataGrid::GridOptionsLoaded', {viewId: self.viewId, name: self.options.gridName});
          }, 0);
        }
      },

      updateUserPreferences: function() {

        var config;

        if (this.loadPreferences) {
          config = angular.extend(this.userPreferences || {}, {
            pageSize: this.pageSize || this.options.paginationPageSize,
            sortField: this.sortField || '',
            sortDirection: this.sortDirection || 'asc',
            columns: this.getColumnConfig(),
            type: 'grid'
          });

          ConfigService.setPreferencesByKey({
            type: ConfigService.settingsTypes.view,
            name: this.viewId,
            configType: config.type,
            key: this.options.gridName,
            value: config
          });

          this.userPreferences = config;
        }

      },

      /**
       * Load preferences for a view from the server
       *
       * @param props {map}
       * @returns {boolean}
       */
      load: function(props) {
        var type = props.type,
          name = props.name,
          self = this;
        if (name && self.loadPreferences) {
          ApiService.userPreferences.get(ConfigService.dotsToDashes(name)).then(function(response) {
            var config = response.data.payload || {};
            ConfigService.setPreferences({
              type: type,
              name: name,
              value: config.preferences || []
            });
            self.getUserPreferences();
            $rootScope.$broadcast('ConfigService::SettingsLoaded', {name: name});
          }, function(response) {
            // No settings saved yet. 404
            if (response && response.status === 404) {
              ConfigService.setPreferences({
                type: type,
                name: name,
                value: []
              });
            }
            self.getUserPreferences();
            $rootScope.$broadcast('ConfigService::SettingsLoaded', {name: name});
          });
        } else {
          self.getUserPreferences();
          $rootScope.$broadcast('ConfigService::SettingsLoaded', {name: name});
        }
      },

      save: function(props) {
        var type = props.type,
          name = props.name;
        if (name) {
          if (ConfigService.settings.hasOwnProperty(type)) {
            if (ConfigService.settings[type].hasOwnProperty(name)) {
              ApiService.userPreferences.update(ConfigService.dotsToDashes(name), ConfigService.settings[type][name]).then(function(response) {
                $rootScope.$broadcast('ConfigService::SettingsSaved', {name: name});
              }, function(response) {
                $rootScope.$broadcast('ConfigService::SettingsSaved', {name: name});
              });
            }
          }
        }
      },

      updateGridHeight: function(datasetLength) {
        var numRows = 1,
            adjustment = this.gridApi.grid.options.enableGrouping ? 30 : 20,
            r = (this.gridApi.grid.options.minRowsToShow * this.gridApi.grid.options.rowHeight + this.gridApi.grid.options.headerRowHeight + this.gridApi.grid.options.gridFooterHeight + adjustment);

        if (datasetLength !== undefined) {
          numRows = datasetLength;
        }
        if (this.gridApi.grid.options.minRowsToShow !== numRows) {
          if (this.gridApi.grid.options.enablePagination) {
            numRows = Math.min(numRows, this.gridApi.grid.options.paginationPageSize);
          }
          r = (numRows * this.gridApi.grid.options.rowHeight + this.gridApi.grid.options.headerRowHeight + this.gridApi.grid.options.gridFooterHeight + adjustment);
        }

        r = r + "px";

        this.gridHeight.height = r;
      },

      expandGroupedRows: function() {
        var self = this;
        $timeout(function() {
          self.gridApi.treeBase.expandAllRows();
        }, 0);
      },

      getGridDefinition: function() {
        return this.options;
      },

      setGridDefinition: function(options) {
        this.options = options;
      },

      getPropertyValue: function(property) {
        return this.options[property];
      },

      setPropertyValue: function(property, value) {
        this.options[property] = value;
      },

      resetGridDefinition: function() {
        this.options = {
          enableVerticalScrollbar: 0,
          enableHorizontalScrollbar: 0,
          showGridFooter: true,
          enableColumnMenus: false,
          enableCellEdit: false,
          enableRowHeaderSelection: true,
          enableRowSelection: true,
          enableSelectionBatchEvent: false,
          showTreeRowHeader: false,
          enableExpandAll: false,
          enableGridMenu: true,
          exporterMenuCsv: false,
          draggable: false,
          multiSelect: false,
          noUnselect: true,
          enableColumnResizing: true,
          enableColumnMoving: true,
          enableSorting: true,
          enablePagination: true,
          useExternalSorting: true,
          useExternalPagination: true,
          enablePaginationControls: true,
          paginationCurrentPage: 1,
          paginationPageSizes: [25, 50, 100, 150, 200, 250],
          paginationPageSize: 50,
          minRowsToShow: 1,
          totalItems: 0,
          treeRowHeaderAlwaysVisible: false,
          flatEntityAccess: false,
          saveFilter: false,
          saveFocus: false,
          saveGrouping: false,
          savePinning: false,
          saveSelection: false,
          saveSort: false,
          saveTreeView: false,
          saveWidths: true,
          columns: []
        };
      },

      setAGGridColumns: function(columnDefs) {
        var i, ii;

        if (Array.isArray(columnDefs)) {
          for (i = 0, ii = columnDefs.length; i < ii; i++) {
            if (columnDefs[i].hasOwnProperty('displayName')) {
              columnDefs[i].headerName = columnDefs[i].displayName;
            }
            if (columnDefs[i].hasOwnProperty('visible')) {
              columnDefs[i].hide = !columnDefs[i].visible;
            }
            if (columnDefs[i].hasOwnProperty('sort')) {
              this.sortField = columnDefs[i].colId || columnDefs[i].field;
              this.sortDirection = columnDefs[i].sort.direction || 'asc';
              if (this.options.api) {
                this.options.api.setSortModel([
                  {
                    colId: this.sortField,
                    sort: this.sortDirection
                  }]);
              }
              columnDefs[i].sort = this.sortDirection;
            }
            if (columnDefs[i].hasOwnProperty('cellTemplate') && !columnDefs[i].hasOwnProperty('template') && !columnDefs[i].hasOwnProperty('cellRenderer')) {
              columnDefs[i].template = columnDefs[i].cellTemplate.replace(/row\.entity/g, 'data');
            }
            if (columnDefs[i].hasOwnProperty('width')) {
              if (
                typeof columnDefs[i].width !== 'string' &&
                !isNaN(parseInt(columnDefs[i].width, 10)) &&
                !columnDefs[i].hasOwnProperty('minWidth')
              ) {
                columnDefs[i].minWidth = parseInt(columnDefs[i].width, 10);
              }
            }
            if (columnDefs[i].hasOwnProperty('enableCellEdit')) {
              if (columnDefs[i].hasOwnProperty('cellEditableCondition')) {
                columnDefs[i].editable = columnDefs[i].cellEditableCondition;
              } else {
                columnDefs[i].editable = columnDefs[i].enableCellEdit;
              }
            }
            if (columnDefs[i].hasOwnProperty('enableSorting') && !columnDefs[i].hasOwnProperty('suppressSorting')) {
              columnDefs[i].suppressSorting = !columnDefs[i].enableSorting;
            }
          }
        }

        this.options.columnDefs = columnDefs;
      },

      /**
      * @param {{
      *  column: Column,
      *  columns: Column[],
      *  toIndex: number,
      *  type: 'columnMoved',
      * }} params
      */
      columnMoved: function (params) {
        var self = this;
        var originalColumnDefs = self.getColumns();
        var fromIndex = originalColumnDefs.findIndex(function (column) {
          return column.field === params.column.colDef.field;
        });

        HelpersService.moveItemInArray(self.options.columnDefs, fromIndex, params.toIndex);
        self.updateUserPreferences();
      },

      columnResized: function (params) {
        var self = this;
        var actualWidth = 0;

        if (params.hasOwnProperty('finished') && params.finished) {
          actualWidth = params.column.actualWidth;

          angular.forEach(self.options.columnDefs, function(item, index) {
            if (item.field === params.column.colDef.field) {
              self.options.columnDefs[index].width = actualWidth;
            }
          });

          self.updateUserPreferences();
        }
      },

      rowDoubleClicked: function(params) {
        var row;

        row = {
          entity: params.data
        };

        if (isFunction(this.options.appScopeProvider.onDblClick)) {
          this.options.appScopeProvider.onDblClick(row);
        }
      },

      cellClicked: function(params) {
        var row, col,
            hasSref = false;

        col = params.colDef;
        row = {
          entity: params.data
        };

        if (col.hasOwnProperty('onCellNavClick') ){

          if (col.hasOwnProperty('template')) {
            if (col.template.indexOf('ui-sref') > -1) {
              hasSref = true;
            }
          }

          if (!hasSref) {
            col.onCellNavClick(row, col, params.event);
          }
        }
      },

      rowSelected: function(params) {
        /**
         * @type {RowSelectedEvent<T>}
         */
        var row = {
          node: params.node,
          entity: params.node.data,
          isSelected: params.node.data.isSelected
        };

        var appScopeProvider = this.options.appScopeProvider;
        var noop = function () {};
        var onDataGridSelectionChange = isFunction(appScopeProvider.onDataGridSelectionChange)
          ? appScopeProvider.onDataGridSelectionChange
          : noop;

        var selectedRows = this.getSelectedRows();

        if (this.options.rowSelection && this.options.rowSelection === 'multiple') {
          if (!params.node.isSelected() && params.node.data.isSelected) {
            // reselect the node if it was toggled with multi select on.
            params.node.setSelected(true);
          } else if (params.node.isSelected() === params.node.data.isSelected) {
            onDataGridSelectionChange(row, selectedRows);
          } else {
            params.node.setSelected(false);
          }
        } else {
          row.isSelected = params.node.selected;
          onDataGridSelectionChange(row, selectedRows);
        }
      },

      selectionChanged: function() {
        var self = this;
        var onDataGridSelectionChanged = isFunction(this.options.appScopeProvider.onDataGridSelectionChanged)
          ? this.options.appScopeProvider.onDataGridSelectionChanged
          : null;

        if (onDataGridSelectionChanged) {
          // Wait until next tick for the selection to be ready
          $timeout(function () {
            var selectedRows = self.getSelectedRows();
            onDataGridSelectionChanged(selectedRows);
          });
        }
      },

      rowClicked: function(params) {
        if (this.options.rowSelection && this.options.rowSelection === 'multiple') {
          var row = params.node.data;
          var selectedRows = this.getSelectedRows();

          var toggleRowSelection = function toggleRowSelection(node) {
            if (node.data.isSelected) {
              node.data.isSelected = false;
              node.setSelected(false);
            } else {
              node.data.isSelected = true;
              node.setSelected(true);
            }
          };
          
          if (this.options.canSelectRow({ row: row, selectedRows: selectedRows })) {
            toggleRowSelection(params.node);
          } else {
            params.node.data.isSelected = false;
            params.node.setSelected(false);
          }
        }
      },

      cellValueChanged: function(params) {
        var row;

        row = {
          entity: params.data
        };

        if (this.options.appScopeProvider && isFunction(this.options.appScopeProvider.onAfterCellEdit)) {
          this.options.appScopeProvider.onAfterCellEdit(row.entity);
        }
      },

      /**
       * UI Grid only for now
       */
      selectRow: function (selected) {
        if (this.isAccessbilityEnabled && this.gridApi) {
          this.gridApi.selection.selectRow(selected);
        }
      },

      /**
       * UI Grid only for now
       */
      unselectRow: function (selected) {
        if (this.isAccessbilityEnabled && this.gridApi) {
          this.gridApi.selection.unSelectRow(selected);
        }
      },

      selectRows: function(selected) {
        var self = this;
        var selectedRows = Array.isArray(selected) ? selected : [];
        var selectedRowsById = _.keyBy(selected, 'id');

        if (self.isAccessbilityEnabled && self.gridApi) {
          selectedRows.forEach(function (row) {
            self.gridApi.selection.selectRow(row);
          });
        } else if (self.options.api) {
          self.options.api.forEachNode(function(node) {
            if (selectedRowsById[node.data.id] && !node.isSelected()) {
              node.setSelected(true);
            } else {
              node.setSelected(false);
            }
          });
        }
      },

      getSelectedRows: function() {
        if (this.gridApi) {
          return this.gridApi.selection.getSelectedRows();
        } else if (this.options.api) {
          return this.options.api.getSelectedRows();
        }
      },

      clearSelection: function() {
        if (this.gridApi) {
          this.gridApi.selection.clearSelectedRows();
        } else if (this.options.api) {
          this.options.api.deselectAll();
        }
      },

      setColumns: function(columns, config) {
        this.options.columnDefs = this.processColumnPreferences(columns, config);

        this.gridOptions.columnDefs = this.options.columnDefs;
        this.setColumnConfig(this.options.columnDefs);
      },

      updateColumns: function(columns) {
        this.setColumns(columns, this.userPreferences);
        this.setAGGridColumns(this.options.columnDefs);
      },

      getColumns: function() {
        return this.options.columnDefs;
      },

      getColumnConfig: function() {
        var cols = this.options.columnDefs || [];
        var columns;

        if (Array.isArray(this.options.columnDefs)) {
          if (Array.isArray(this.columnConfig) && this.columnConfig.length === this.options.columnDefs.length) {
            cols = this.columnConfig;
          }

          columns = cols.map(function(column){
            var name = column.name || column.field;
            var visible = true;
            var actualWidth = 0;

            if (column.hide || (column.visible !== undefined && column.visible !== null && !column.visible)) {
              visible = false;
            }

            if (
              column.hasOwnProperty('width') &&
              typeof column.width !== 'string' &&
              !isNaN(parseInt(column.width, 10))
            ) {
              actualWidth = parseInt(column.width, 10);
            }

            return {
              name: name,
              visible: visible,
              actualWidth: actualWidth
            };
          });
        }

        return Array.isArray(columns) ? columns : [];
      },

      setColumnConfig: function(cols) {
        this.columnConfig = Array.isArray(cols) ? cols : [];
      },

      processColumnPreferences: function(columnDef, config) {

        var configColumn,
            i, ii,
            index,
            optionsFields = columnDef.map(function(col) { return col.field; }),
            columns = [],
            invalid = false,
            sort = false,
            existsMap;

        if (config) {
          if (config.sortField && this.options.enableSorting) {
            this.sortField = config.sortField;
            this.sortDirection = config.sortDirection || 'asc';
          }

          if (Array.isArray(config.columns) && config.columns.length) {
            for (i = 0, ii = config.columns.length; i < ii; i++) {
              configColumn = config.columns[i];
              index = optionsFields.indexOf(configColumn.name);
              if (index > -1) {
                // if hiding is allowed, toggle visibility
                if (columnDef[index].enableHiding !== undefined && columnDef[index].enableHiding === false) {
                  columnDef[index].visible = true;
                } else {
                  columnDef[index].visible = (configColumn.visible === undefined) ? true : configColumn.visible;
                }
                if ( this.sortField ) {
                  if ((this.sortField === configColumn.name) ||
                    (columnDef[index].colId && this.sortField === columnDef[index].colId)) {
                    columnDef[index].sort = {direction: this.sortDirection};
                    if (this.gridApi) {
                      this.gridApi.grid.sortColumn(this.gridApi.grid.getColumn(columnDef[index].field), this.sortDirection);
                    }
                  } else if (columnDef[index].hasOwnProperty('sort')) {
                    delete(columnDef[index].sort);
                  }
                }
                if (configColumn.actualWidth > 0) {
                  if (columnDef[index].hasOwnProperty('width')) {
                    columnDef[index].minWidth = columnDef[index].width;
                  } else {
                    columnDef[index].minWidth = 30;
                  }
                  columnDef[index].width = configColumn.actualWidth;
                }
                columns.push(columnDef[index]);
              } else {
                invalid = true;
                break;
              }
            }

            // then add any ones that are missing in user preferences are added. Enable hiding false are always visible.
            existsMap = columns.map(function(col) { return col.field; }) || [];

            for (i = 0, ii = columnDef.length; i < ii; i++) {
              if (existsMap.indexOf(columnDef[i].field) < 0) {
                if (columnDef[i].enableHiding !== undefined && columnDef[i].enableHiding === false) {
                  columnDef[i].visible = true;
                } else if (columnDef[i].enableHiding === undefined || columnDef[i].enableHiding){
                  // We have new columns added to the grid, so reset the columns
                  invalid = true;
                }
                columns.push(columnDef[i]);
              }
            }

            if (!invalid) {
              columnDef = columns;
            }
          }
        } else {
          // set default sort
          for (i = 0, ii = columnDef.length; i < ii; i++) {
            if (columnDef[i].hasOwnProperty('sort')) {
              this.sortField = columnDef[i].colId || columnDef[i].field;
              this.sortDirection = columnDef[i].sort.direction || 'asc';
              break;
            }
          }
        }

        return columnDef;
      },

      applyPreferences: function(config) {
        if (config) {
          this.processPaginationPreferences(config.pageSize, this.options.paginationPageSizes);
        }
      },

      processPaginationPreferences: function(pageSize, pageSizes) {
        if (pageSize && !isNaN(parseInt(pageSize, 10)) && (pageSizes.indexOf(pageSize) > -1)) {
          this.gridOptions.paginationPageSize = this.options.paginationPageSize = pageSize;
          this.pageSize = pageSize;
          this.page = 1;
        }
      },

      getGridState: function() {
        var r = {};
        if (this.page) {
          r.page = this.page;
        }
        if (this.pageSize) {
          r.pageSize = this.pageSize;
        } else {
          r.pageSize = this.options.paginationPageSize;
        }
        if (this.sortField) {
          r.sortField = this.sortField;
        }
        if (this.sortDirection) {
          r.sortDirection = this.sortDirection;
        }
        return r;
      },

      setColumnVisibility: function(props) {
        var i, ii, prop;
        for (prop in props) {
          if (props.hasOwnProperty(prop)) {
            for (i = 0, ii = this.options.columnDefs.length; i < ii; i++) {
              if (this.options.columnDefs[i].field === prop) {
                this.options.columnDefs[i].visible = props[prop];
                if (this.options.columnApi) {
                  this.options.columnDefs[i].hide = !this.options.columnDefs[i].visible;
                  this.options.columnApi.setColumnVisible(this.options.columnDefs[i].field, this.options.columnDefs[i].visible);
                }
                break;
              }
            }
          }
        }
      },

      setPageNumber: function(page) {
        this.options.paginationCurrentPage = this.gridOptions.paginationCurrentPage= this.options.pageNumber = page;
      },

      setRowSelectionMode: function (rowSelectionMode) {
        var self = this;

        self.options.rowSelection = rowSelectionMode;
        self.options.multiSelect = rowSelectionMode === 'multiple';
        self.gridOptions.multiSelect = rowSelectionMode === 'multiple';
      }

    };
  }

  return GridDefinition;

}]);

